/**
 * Utility functions for authentication
 */

import client from './client';

/**
 * Sets the authentication token and resets the Apollo cache
 * to ensure all subsequent requests use the new token
 * 
 * @param {string} token - JWT token received from the backend
 * @returns {Promise} - Promise resolving after cache reset
 */
export function setAuthToken(token) {
  if (!token) {
    console.error('Attempted to set empty auth token');
    return Promise.reject(new Error('Invalid token'));
  }
  
  // Store token in localStorage
  localStorage.setItem('token', token);
  
  // Reset Apollo store to ensure the new token is used in subsequent requests
  return client.resetStore().catch(error => {
    console.error('Error resetting Apollo cache after token update:', error);
    // Continue despite errors
    return Promise.resolve();
  });
}

/**
 * Checks if the current user is authenticated
 * 
 * @returns {boolean} - True if authenticated, false otherwise
 */
export function isAuthenticated() {
  const token = localStorage.getItem('token');
  return !!token;
}
